import React, { CSSProperties, FC } from 'react'

import { observer } from 'mobx-react'

import cn from 'classnames'

import { useStore } from 'store'

import { ReactComponent as LIVEIcon } from 'sources/images/LIVE.svg'

import styles from './styles.module.scss'

interface IProps {
  style?: CSSProperties
}
export const LiveIcon: FC<IProps> = ({ style }) => {
  return (
    <div className={styles.liveIcon} style={style}>
      <LIVEIcon />
    </div>
  )
}

LiveIcon.displayName = 'LiveIcon'
